import {TAction} from './types';

export function createAction<P>(type: string) {
    return (payload?: P) => ({type, payload});
}

type THandlersMap = Record<string, Function>
export const createReducer = (
    initialState: object,
    handlers: THandlersMap,
) => (state = initialState, action: TAction) => {
    if (handlers[action.type]) {
        return handlers[action.type](state, action);
    }
    return state;
};
